import styled from 'styled-components';
import { rem } from '../../utils/functions.js';
import { BUTTON_VARIANT, TEXT_HEIGHT } from './constants.js';
import { getTextColor } from './utils.js';
import { typography } from '../../typography/typography.js';

function getBackgroundColor(variant, hover, active, disabled, theme) {
  switch (variant) {
    case BUTTON_VARIANT.TERTIARY:
    case BUTTON_VARIANT.TERTIARY_BACK:
    case BUTTON_VARIANT.TERTIARY_NOICON:
      return 'transparent';
    case BUTTON_VARIANT.SECONDARY:
      if (disabled) {
        return theme.colorPalette.neutralColors.light.shade_dark_3;
      }
      if (active) {
        return theme.colorPalette.accentColor.shade_dark_2;
      }
      if (hover) {
        return theme.colorPalette.accentColor.shade_dark_1;
      }
      return theme.colorPalette.neutralColors.light.shade_white;
    case BUTTON_VARIANT.SIGN_IN:
      if (disabled) {
        return theme.colorPalette.neutralColors.light.shade_dark_3;
      }
      if (active) {
        return theme.colorPalette.secondaryColors.two.shade_dark_1;
      }
      if (hover) {
        return theme.colorPalette.secondaryColors.two.shade_default;
      }
      return theme.colorPalette.secondaryColors.two.shade_light_1;
    default:
      if (disabled) {
        return theme.colorPalette.neutralColors.light.shade_dark_3;
      }
      if (active) {
        return theme.colorPalette.accentColor.shade_dark_2;
      }
      if (hover) {
        return theme.colorPalette.accentColor.shade_dark_1;
      }
      return theme.colorPalette.accentColor.shade_default;
  }
}
function getBorderColor(variant, hover, active, disabled, theme) {
  switch (variant) {
    case BUTTON_VARIANT.TERTIARY:
    case BUTTON_VARIANT.TERTIARY_BACK:
    case BUTTON_VARIANT.TERTIARY_NOICON:
    case BUTTON_VARIANT.SIGN_IN:
      return 'transparent';
    default:
      if (active) {
        return theme.colorPalette.accentColor.shade_dark_2;
      }
      if (disabled) {
        return theme.colorPalette.neutralColors.light.shade_dark_3;
      }
      if (hover) {
        return theme.colorPalette.accentColor.shade_dark_1;
      }
      return theme.colorPalette.accentColor.shade_default;
  }
}
var ButtonWrapper = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__ButtonWrapper",
  componentId: "sc-np7t5k-0"
})(["display:inline-flex;justify-content:center;align-items:center;min-width:", ";font-family:", ";font-size:", ";font-weight:", ";position:relative;box-sizing:border-box;background-color:", ";color:", ";border-width:2px;border-style:solid;border-color:", ";padding:12px 24px;text-decoration:none;cursor:pointer;&:active{background-color:", ";color:", ";border-color:", ";}&:hover,&:focus{background-color:", ";color:", ";border-color:", ";}&:focus:not(:focus-visible){background-color:", ";color:", ";border-color:", ";}&:hover,&:active,&:focus{cursor:", ";position:relative;overflow:hidden;transform:translate3d(0,0,0);}i,img{color:", ";font-size:", ";line-height:", ";position:relative;top:4px;margin-right:10px;}", ""], function (_ref) {
  var variant = _ref.variant;
  return BUTTON_VARIANT.PRIMARY === variant || BUTTON_VARIANT.SECONDARY === variant ? '200px' : 'auto';
}, typography.fontFamily, function (_ref2) {
  var variant = _ref2.variant;
  return BUTTON_VARIANT.PRIMARY === variant || BUTTON_VARIANT.SECONDARY === variant ? rem(19) : typography.fontSize;
}, function (_ref3) {
  var variant = _ref3.variant;
  return BUTTON_VARIANT.TERTIARY === variant || BUTTON_VARIANT.TERTIARY_BACK === variant || BUTTON_VARIANT.TERTIARY_NOICON === variant ? '400' : '700';
}, function (_ref4) {
  var variant = _ref4.variant,
    active = _ref4.active,
    disabled = _ref4.disabled,
    theme = _ref4.theme;
  return getBackgroundColor(variant, false, active, disabled, theme);
}, function (_ref5) {
  var variant = _ref5.variant,
    active = _ref5.active,
    disabled = _ref5.disabled,
    theme = _ref5.theme;
  return getTextColor(variant, false, active, disabled, theme);
}, function (_ref6) {
  var variant = _ref6.variant,
    active = _ref6.active,
    disabled = _ref6.disabled,
    theme = _ref6.theme;
  return getBorderColor(variant, false, active, disabled, theme);
}, function (_ref7) {
  var variant = _ref7.variant,
    disabled = _ref7.disabled,
    theme = _ref7.theme;
  return getBackgroundColor(variant, false, true, disabled, theme);
}, function (_ref8) {
  var variant = _ref8.variant,
    disabled = _ref8.disabled,
    theme = _ref8.theme;
  return getTextColor(variant, false, true, disabled, theme);
}, function (_ref9) {
  var variant = _ref9.variant,
    disabled = _ref9.disabled,
    theme = _ref9.theme;
  return getBorderColor(variant, false, true, disabled, theme);
}, function (_ref10) {
  var variant = _ref10.variant,
    active = _ref10.active,
    disabled = _ref10.disabled,
    theme = _ref10.theme;
  return getBackgroundColor(variant, true, active, disabled, theme);
}, function (_ref11) {
  var variant = _ref11.variant,
    active = _ref11.active,
    disabled = _ref11.disabled,
    theme = _ref11.theme;
  return getTextColor(variant, true, active, disabled, theme);
}, function (_ref12) {
  var variant = _ref12.variant,
    active = _ref12.active,
    disabled = _ref12.disabled,
    theme = _ref12.theme;
  return getBorderColor(variant, true, active, disabled, theme);
}, function (_ref13) {
  var variant = _ref13.variant,
    hover = _ref13.hover,
    active = _ref13.active,
    disabled = _ref13.disabled,
    theme = _ref13.theme;
  return getBackgroundColor(variant, hover, active, disabled, theme);
}, function (_ref14) {
  var variant = _ref14.variant,
    hover = _ref14.hover,
    active = _ref14.active,
    disabled = _ref14.disabled,
    theme = _ref14.theme;
  return getTextColor(variant, hover, active, disabled, theme);
}, function (_ref15) {
  var variant = _ref15.variant,
    hover = _ref15.hover,
    active = _ref15.active,
    disabled = _ref15.disabled,
    theme = _ref15.theme;
  return getBorderColor(variant, hover, active, disabled, theme);
}, function (_ref16) {
  var disabled = _ref16.disabled,
    saving = _ref16.saving;
  if (disabled) {
    return 'not-allowed';
  }
  if (saving) {
    return 'progress';
  }
  return '';
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, rem(24), rem(20), function (_ref18) {
  var buttonStyle = _ref18.buttonStyle;
  return buttonStyle;
});
process.env.NODE_ENV !== "production" ? ButtonWrapper.displayName = 'ButtonWrapper' : void 0;
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-np7t5k-1"
})(["box-sizing:border-box;line-height:", ";margin-right:7px;display:inline-flex;pointer-events:none;color:", ";"], rem(TEXT_HEIGHT), function (_ref19) {
  var variant = _ref19.variant,
    active = _ref19.active,
    disabled = _ref19.disabled,
    hovered = _ref19.hovered,
    theme = _ref19.theme;
  if (variant !== BUTTON_VARIANT.TERTIARY && variant !== BUTTON_VARIANT.TERTIARY_BACK) {
    return theme.colorPalette.neutralColors.light.shade_white;
  }
  if (disabled) {
    return theme.colorPalette.neutralColors.light.shade_dark_3;
  }
  if (active) {
    return theme.colorPalette.accentColor.shade_dark_2;
  }
  if (hovered) {
    return theme.colorPalette.accentColor.shade_dark_1;
  }
  return theme.colorPalette.accentColor.shade_default;
});
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : void 0;
var SpinnerWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__SpinnerWrapper",
  componentId: "sc-np7t5k-2"
})(["margin-left:10px;height:", ";width:", ";"], rem(TEXT_HEIGHT), rem(TEXT_HEIGHT));
process.env.NODE_ENV !== "production" ? SpinnerWrapper.displayName = 'SpinnerWrapper' : void 0;

export { ButtonWrapper, IconWrapper, SpinnerWrapper };
